import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=04c8584b&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=04c8584b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8584b",
  null
  
)

export default component.exports